import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { AiOutlineDownload } from "react-icons/ai";
import { RiCloseLargeLine } from "react-icons/ri";
import "../styles/termofuse.css";

function TermOfuse() {
  const location = useLocation();
  const pathname = location.pathname;

  // useEffect(() => {
  //   if (pathname === "/termofuse") {
  //     document.querySelector(".site-header").classList.add("hidden");
  //   }
  // }, [pathname]);

  return (
    <main className="site-main">
      <div className="bg-white relative">
        <Link to={"/"} className="button-close absolute top-4 right-4 z-10">
          <RiCloseLargeLine />
        </Link>
        <div className="container mx-auto relative z-[2] py-20">
          <div className="flex flex-auto flex-wrap">
            <div className="w-4/12 p-4 flex items-center justify-center">
              <div>
                <img
                  className="w-[240px] p-4 mb-4"
                  src="/images/logo-color-brand.png"
                  alt=""
                />
                <img
                  className="w-[240px]"
                  src="/images/logo-white-brand.png"
                  alt=""
                />
              </div>
            </div>
            <div className="w-8/12 p-4">
              <div>
                <h1 className="text-black text-2xl font-semibold mb-4">
                  ตราสัญลักษณ์ของสำนักงานการรักษาความมั่นคงปลอดภัยไซเบอร์แห่งชาติ
                </h1>
                <p className="text-black text-md font-medium py-10">
                  ภูมิทัศน์ บึมพาสเจอร์ไรส์เมี่ยงคำวัคค์สมิติเวช
                  วิลเลจรีสอร์ทออร์แกนิกจิตพิสัย เบญจมบพิตรแอนด์ อุตสาหการ
                  บึมวัคค์ฮิปฮอปเช็กแมชีน จังโก้ฮอตดอกรีสอร์ตอุปนายิกา
                  มิวสิคเนอะมะกัน ฮีโร่โลิมูซีน ตาปรือ ฮีโร่ ฮ็อตอะ ซีเรียส
                  สต๊อกจัมโบ้ สโตร์เวิร์กช็อปออยล์ เดชานุภาพล็อบบี้บิ๊กเซ็กส์
                </p>
                <h2 className="text-black text-lg font-semibold mb-4">
                  การใช้โลโกและสีประจำองค์กร
                </h2>
                <p className="text-black text-md font-medium pb-10">
                  โลโกไฟล์ .jpg และ .png
                </p>
                <h2 className="text-black text-lg font-semibold mb-4">
                  สีหลักที่ใช้ในงาน
                </h2>
                <div className="flex items-center py-4">
                  <div className="block-set-color">
                    <div className="color-stage bg-[#040707]" />
                    <div className="text-stage">#040707</div>
                  </div>
                  <div className="block-set-color">
                    <div className="color-stage bg-[#272974]" />
                    <div className="text-stage">#272974</div>
                  </div>
                  <div className="block-set-color">
                    <div className="color-stage bg-[#ed1f24]" />
                    <div className="text-stage">#ed1f24</div>
                  </div>
                  <div className="block-set-color">
                    <div className="color-stage bg-[#b3b4b4]" />
                    <div className="text-stage">#b3b4b4</div>
                  </div>
                </div>
                <div className="p-4">
                  <button type="button" className="button-red-main">
                    <div className="flex items-center justify-center">
                      <AiOutlineDownload />
                      <span className="block ml-2">ดาวน์โหลดโลโก้</span>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default TermOfuse;
